import { File, FileArchive, FileSpreadsheet, FileText, Presentation, type LucideIcon } from "lucide-react";

export interface FileTypeMeta {
    icon: LucideIcon;
    badgeClass: string;
    iconWrapClass: string;
}

const PDF_DOC: FileTypeMeta = {
    icon: FileText,
    badgeClass: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300",
    iconWrapClass: "bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-400",
};
const WORD_DOC: FileTypeMeta = {
    icon: FileText,
    badgeClass: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
    iconWrapClass: "bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400",
};
const SHEET: FileTypeMeta = {
    icon: FileSpreadsheet,
    badgeClass: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300",
    iconWrapClass: "bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400",
};
const SLIDE: FileTypeMeta = {
    icon: Presentation,
    badgeClass: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
    iconWrapClass: "bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-400",
};
const ARCHIVE: FileTypeMeta = {
    icon: FileArchive,
    badgeClass: "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300",
    iconWrapClass: "bg-violet-50 text-violet-600 dark:bg-violet-900/30 dark:text-violet-400",
};
const DEFAULT: FileTypeMeta = {
    icon: File,
    badgeClass: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
    iconWrapClass: "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
};

export function getFileTypeMeta(fileType: string | null | undefined): FileTypeMeta {
    const ext = (fileType || "").toLowerCase().replace(".", "");
    if (ext === "pdf") return PDF_DOC;
    if (["doc", "docx"].includes(ext)) return WORD_DOC;
    if (["xls", "xlsx", "csv"].includes(ext)) return SHEET;
    if (["ppt", "pptx"].includes(ext)) return SLIDE;
    if (["zip", "rar", "7z"].includes(ext)) return ARCHIVE;
    return DEFAULT;
}
